import React from 'react';
import styled from 'styled-components';
import { get, Icon } from '@ally/metronome-ui';
import { deprecated } from '@ally/metronome-icons';
const MarkerOuterWrapper = styled.div `
  height: ${get.space('lg')};
  display: flex;
  align-items: center;
  position: relative;
`;
const MarkerInnerWrapper = styled.div `
  ${({ props: { markerType, status, hasProgress }, theme: { colors, media }, }) => `
    width: 100%;
    &:before,
    &:after {
      position: absolute;
      top: 50%;
      overflow: hidden;
      width: 51%;
      height: 1px;
      content: "";
      background-color: ${colors['slate-2']};
      margin-top: initial;
    }

    &:before {
      margin-left: -50%;
      text-align: right;

      ${markerType === 'start' ? `display: none;` : ``}

      ${markerType === 'end'
    ? `
          ${media.down('md')} {
              width: 100%;
              margin-left: -100%;
            }
      `
    : ``}

      ${status === 'Current' || status === 'Success' || status === 'Warning'
    ? `
          background-color: ${colors.plum};
      `
    : ``}
    }

    &:after {
      ${markerType === 'start'
    ? `
            width: 100%;
            left: 35px;
            ${media.down('md')} {
              left: initial;
            }
          `
    : ``}

      ${(markerType === 'start' && hasProgress) ||
    (markerType === 'default' && status === 'Success')
    ? `background-color: ${colors.plum};`
    : ``}

      ${markerType === 'end' ? `display: none;` : ``}
    }
  `}
`;
const Marker = styled.div `
  ${({ props: { hasProgress, isFirstStep, markerType, status }, theme: { colors, media, space }, }) => `
    position: relative;
    z-index: 1;
    width: 6px;
    height: 6px;
    margin: 0 auto;

    ${markerType === 'start'
    ? `
      width: ${space.md};
      height: ${space.md};
      background-color: ${colors.white};
      margin-left: 27px;
      ${isFirstStep === true && !hasProgress
        ? `
            outline: ${space.xs} solid ${colors.white};
          `
        : ``}
      ${media.down('md')} {
        margin-left: 0;
      }
    `
    : ``}

    ${markerType === 'end'
    ? `
      width: ${space.md};
      height: ${space.md};
      background-color: ${colors.white};
      ${media.down('md')} {
        margin-right: 0;
      }
    `
    : ``}

    ${markerType === 'default'
    ? `
        border-radius: 50%;
      ${status === 'Warning' ? `background-color: ${colors.warning};` : ``}
      ${status === 'Current' ? `background-color: ${colors.plum};` : ``}
      ${media.down('md')} {
        top: 9px;
      }
    `
    : ``}
  `}
`;
const SummaryTrackerMarker = props => {
    const { markerType, status } = props;
    const showIcon = markerType === 'start' || markerType === 'end';
    const iconType = () => {
        if (status === 'Warning')
            return deprecated.muiErrorFill;
        return status === 'Success'
            ? deprecated.muiSuccessFill
            : deprecated.muiSuccessOutline;
    };
    const iconFill = () => {
        if (status === 'Warning')
            return 'warning';
        if (status === 'Success')
            return 'plum';
        return 'slate-400';
    };
    return (React.createElement(MarkerOuterWrapper, null,
        React.createElement(MarkerInnerWrapper, { props: props },
            React.createElement(Marker, { props: props }, showIcon && (React.createElement(Icon, { icon: iconType(), fill: iconFill(), size: "md", "aria-hidden": true }))))));
};
export default SummaryTrackerMarker;
//# sourceMappingURL=SummaryTrackerMarker.js.map